module.exports = __webpack_public_path__ + "img/selected6-min.e5b2483c.png";